<script>
    import debounce from 'lodash/debounce';

    export default {
        name: 'App',
        methods: {
            listenWindowResize() {
                if (this.windowResizeStarted) {
                    return;
                }
                this.windowResizeStarted = true;
                const component = this;
                window.addEventListener('resize', debounce(function (e) {
                    // Save the sizes.
                    component.$window.updateWindowSizes();
                    if(typeof component.$bus !== 'undefined') {
                      component.$bus.$emit('window:resize', component.$window.width, component.$window.height);
                    }
                }, 500));
            },

        },

        mounted() {
            this.listenWindowResize();
        },
    };
</script>

